module.exports = __webpack_public_path__ + "img/shop_jd.67430749.png";